// extracted by mini-css-extract-plugin
module.exports = {"section":"_3tDEZrZC7U9ouMwQJkS1hR","inner":"_32CM_iPNdC_Z7psgScrCI-","body":"aax4CKtNxckv8HkDJoFpu"};